import Vue from 'vue'

import { bearerInterceptor } from '@/bootstrap/interceptors/bearer.interceptor.js'
import { errorInterceptor } from '@/bootstrap/interceptors/error.interceptor.js'
import { refreshInterceptor } from '@/bootstrap/interceptors/refreshToken.interceptor.js'

function bootInterceptors () {
    var interceptors = []

    interceptors.push(bearerInterceptor, errorInterceptor, refreshInterceptor)

    for (let i = 0; i < interceptors.length; i++) {
        if (interceptors[i].type === 'request') {
            Vue.axios.interceptors.request.use(
                interceptors[i].process,
                interceptors[i].exception
            )
        } else if (interceptors[i].type === 'response') {
            Vue.axios.interceptors.response.use(
                interceptors[i].process,
                interceptors[i].exception
            )
        }
    }
}

export { bootInterceptors }
